/*
 * File: FeeSchedules.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows the provider, office, fee information
 */
import React, { useEffect, useState, useCallback } from "react";
import { List, Toolbar } from "@material-ui/core";
import ProviderOfficeFeeModel from "services/patients/demographics/provider_office_fee/store/ProviderOfficeFeeModel";
import UIListItem from "components/ui/UIListItem";
import UIProgress from "components/ui/UIProgress";
import ProviderOfficeFeeFab from "./components/ProviderOfficeFeeFab";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "services/patients/topofthechart/PatientChart";
import FabSpacer from "components/ui/FabSpacer";
import MainHeader from "components/MainHeader";
import { useStore } from "utils/useStore";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    paddingBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2.5)
  }
});

const FeeSchedules = ({ classes }) => {
  const providerOfficeFeeModel = useStore(ProviderOfficeFeeModel);
  const [loading, setLoading] = useState(true);

  const updateModel = useCallback(async () => {
    setLoading(true);
    await providerOfficeFeeModel.getProviderOfficeFeeData();

    setLoading(false);
  }, [providerOfficeFeeModel]);

  useEffect(() => {
    updateModel();
  }, [updateModel]);

  const fullName = providerModel => {
    if (providerModel.firstName && providerModel.lastName)
      return providerModel.firstName + " " + providerModel.lastName;
    else return "";
  };

  if (loading) return <UIProgress />;
  else {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle="Provider, Office, & Fee Schedule"
            pageSubtitle="Patient"
          />
        </Toolbar>
        <List>
          <UIListItem
            label="Account Provider"
            value={fullName(providerOfficeFeeModel.accountProvider)}
          />
          <UIListItem
            label="Patient Provider"
            value={fullName(providerOfficeFeeModel.patientProvider)}
          />
          <UIListItem
            label="Office"
            value={providerOfficeFeeModel.patientOffice.name}
          />
          <UIListItem
            label="Fee Schedule"
            value={providerOfficeFeeModel.feeSchedule.name}
          />
          <FabSpacer />
        </List>
        <ProviderOfficeFeeFab
          providerOfficeFeeModel={providerOfficeFeeModel}
          editCallBack={updateModel}
        />
      </React.Fragment>
    );
  }
};

FeeSchedules.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FeeSchedules);
